<ion-content>
  <ion-list>
    <ion-item>
      <ion-label>
        <h2 translate>Mobile.DeviceName</h2>
        <p>{{ deviceName }}</p>
      </ion-label>
    </ion-item>
    <ion-item *ngIf="phoneNumber">
      <ion-label>
        <h2 translate>Mobile.PhoneNumber</h2>
        <p>{{ phoneNumber }}</p>
      </ion-label>
    </ion-item>
    <ion-item *ngIf="appVersion">
      <ion-label>
        <h2 translate>Mobile.AppVersion</h2>
        <p>{{ appVersion }}</p>
      </ion-label>
    </ion-item>
    <ion-item *ngIf="appBuildNumber">
      <ion-label>
        <h2 translate>Mobile.AppBuild</h2>
        <p>{{ appBuildNumber }}</p>
      </ion-label>
    </ion-item>
  </ion-list>
</ion-content>
